import styled from '@emotion/styled'

export const StyledEditorContent = styled.div((props) => {
  const { fontSize, lineHeight } = props.theme.dimensions.small
  return `
    font-size: ${fontSize};
    line-height: ${lineHeight};
  `
})
